/**
 * Maintenance mode – edit this file to enable/disable and update the message.
 * Set enabled to true to show the maintenance page; false to show the app.
 */

export const maintenanceConfig = {
  enabled: false,

  title: "We'll be back soon",
  message:
    "We're currently performing scheduled maintenance to improve your experience. Please check back soon.",
  estimatedTime: "",
  contact: "",
};

export const isMaintenanceMode = (): boolean => maintenanceConfig.enabled;
